// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__x0arE","leftSection":"Footer_leftSection__qwWmd","rightSection":"Footer_rightSection__wNYTl"};